import React, { useEffect, useState } from "react";
import api from "../../api";
import SupplierProvinceAccordion from "../../components/SupplierDelivery/SupplierProvinceAccordion";

export default function SupplierDeliveryDuration() {
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchWarehouses();
    fetchProvinces();
  }, []);

  const fetchWarehouses = async () => {
    try {
      const { data } = await api.get("/products/warehouses-address/");
      setWarehouses(data);
      const defaultWh = data.find((w) => w.is_default) || data[0];
      setSelectedWarehouse(defaultWh || null);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProvinces = async () => {
    try {
      const { data } = await api.get("/accounts/provinces/");
      setProvinces(data || []);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <div className="mb-8 space-y-4">
  {/* باکس انتخاب انبار */}
  <div className="flex flex-col md:flex-row md:items-center gap-2">
    <label className="text-sm font-bold text-gray-700 whitespace-nowrap">انتخاب انبار:</label>
    <select
        value={selectedWarehouse?.id || ""}
        onChange={(e) => setSelectedWarehouse(warehouses.find(w => w.id === Number(e.target.value)))}
        // عرض ریسپانسیو: در موبایل تمام صفحه، در تبلت و دسکتاپ حداکثر 300px
        className="w-full md:w-[400px] px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 transition-all"
    >
      {warehouses.map((wh) => (
          <option key={wh.id} value={wh.id}>
            {wh.title} {wh.is_default ? "(پیش‌فرض)" : ""}
          </option>
      ))}
    </select>
  </div>

        {/* نمایش شکیل جزئیات انبار در زیر باکس */}
        {selectedWarehouse && (
            <div className="bg-blue-50 border border-blue-100 p-4 rounded-xl flex items-center gap-6 text-sm">
              <div>
                <span className="text-gray-500 block text-xs mb-1">عنوان انبار</span>
                <span className="font-bold text-blue-900 text-base">{selectedWarehouse.title}</span>
              </div>
              <div className="h-8 w-[1px] bg-blue-200"></div>
              {/* جداکننده عمودی */}
              <div>
                <span className="text-gray-500 block text-xs mb-1">موقعیت</span>
                <span className="font-semibold text-gray-700">
          {selectedWarehouse.province_name}، {selectedWarehouse.city_name}
        </span>
              </div>
            </div>
        )}
      </div>


      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {provinces.map((province) => (
            <SupplierProvinceAccordion
                key={province.id}
                province={province}
                warehouseId={selectedWarehouse?.id}
            />
        ))}
      </div>
    </div>
  );
}
